(function () {

  /* START OBJECT Animation preloader */
      var animateLoader = {};

      animateLoader.Constants = {
          bgColors: ['#FAF8DC', '#FCECCF', '#FCECCF'],
      }

      animateLoader.preLoader = function(){
          var counter = 0;
          jQuery('#container_bg').removeClass('hide');
          var animateBg = setInterval(function(){
              if( counter == animateLoader.Constants.bgColors.length ){
                  clearInterval(animateBg);
                  jQuery('main').css('opacity', 1);
                  jQuery('#container_bg').animate({
                      opacity: 0,
                  }, 2000, function(){
                    jQuery('#container_bg').css('z-index', '-1');
                  });
                  return;
              }
              var bgColor = animateLoader.Constants.bgColors[counter];
              jQuery('#container_bg').animate({
                  backgroundColor: bgColor,
              }, 1000);
              counter++;
          }, 1000);
      }

      animateLoader.sun = function(){
          setTimeout(function(){
              jQuery("#sun").animate({
                  width: '4000px',
                  height: '4000px',
              }, 3000, function(){
                jQuery(this).addClass('blur');
              })
          }, 500)
      }

      animateLoader.logo = function(){
          var topPosition = jQuery("#title-logo").offset().top - 22;
          jQuery("#title-logo").animate({
              opacity: 1,
          }, 1000);

          setTimeout(function(){
              jQuery('#title-logo').css('transform', 'translateY(-'+ topPosition +'px)');
          }, 1000);

          animateLoader.before_bg();
      }

      animateLoader.before_bg = function(){
          jQuery("#before-bg").animate({
              opacity: 0,
          }, 1000);
      }

      animateLoader.pageLoader = function(){
          jQuery('#page-load').css('display', 'block');
          jQuery('#sun-bg').animate({
              top: 100,
              bottom: 0,
          }, 1500, function(){
              jQuery('#sun-bg').animate({
                  right: '-100%',
                  top: '-200px',
                  //margin: '0 auto',
              }, 2000, function(){
                  jQuery('main').css('opacity', 1);
                  jQuery('#page-load').animate({
                      opacity: 0,
                  }, 500, function(){
                    jQuery('#page-load').css('z-index', '-1');
                  });
              });
          });
      }

  /* END  OBJECT */


      jQuery(document).ready(function(){
        var firstLoad = sessionStorage.getItem('firstLoad');

        if( !firstLoad ){
          /* site preloader */
             // animateLoader.preLoader();
             // animateLoader.sun();
             // setTimeout(function(){
               //   animateLoader.logo();
             // }, 1000);
             // sessionStorage.setItem('firstLoad', true);
          /* end site preloader */
        } else {
          /* page preloader */
                //  animateLoader.pageLoader();
          /* end page preloader */
          jQuery('main').removeClass('opacity');
        }

        jQuery('main').removeClass('opacity');
      });


})(jQuery)
